// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-medium-text-aef35a4d"};